// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s1-0";
export var fileList = "_s1-2";
export var removeFileButton = "_s1-1";